<template>
  <v-sheet
    :id="`${props.target}`"
    :color="props.color_background ? props.color_background : '#FFFFFF'"
    :class="`
      pt-${props.pt ? props.pt : '0'} 
      pb-${props.pb ? props.pb : '0'}`">
    <v-container fluid v-if="props" class="container-padding py-12">
      <v-row align="start">
        <!-- Image -->
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="6"
          align="center">
          <img
            v-if="props.img_href"
            :src="props.img_href"
            :width="`${props.img_width ? props.img_width : 160}px`"
            style="max-width: 100%" />
        </v-col>
        <!-- Text -->
        <v-col cols="12" sm="6" md="6" lg="6">
          <h2
            v-if="props.headline && props.headline[language]"
            class="mb-3 text-h6 font-weight-bold"
            v-html="props.headline[language]"></h2>
          <div
            v-if="props.text && props.text[language]"
            v-html="props.text[language]"></div>
          <!-- Text link -->
          <router-link
            v-if="props.link && props.link_text && props.link_text[language]"
            class="d-inline-block mt-3 font-weight-bold"
            :to="props.link"
            v-html="props.link_text[language]"></router-link>
          <!-- Button -->
          <v-row v-if="props.button_text && props.button_text[language]">
            <v-col :align="$vuetify.breakpoint.xs ? 'center' : 'left'">
              <v-btn
                class="px-4 py-5"
                color="secondary"
                :to="props.link"
                v-html="props.button_text[language]"></v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Edit dialog -->
      <v-dialog v-if="edit" persistent v-model="edit" fullscreen>
        <v-card>
          <v-card-title class="text-h5 black white--text">
            Edit Component
          </v-card-title>
          <v-card-text class="pt-5">
            <Core
              name="Core"
              :editProps="editProps"
              @emitProps="setPreviewProps"
              @save="save"
              @cancel="cancel" />
            <!-- Preview -->
            <h2 class="my-2 text-h4 black--text">Preview:</h2>
            <CompImageText
              v-if="previewProps"
              name="CompImageText"
              :props="previewProps" />
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import CompImageText from "./CompImageText";
import Core from "../editor/Core.vue";

export default {
  name: "CompImageText",
  props: ["props", "edit", "index", "componentId"],
  data() {
    return {
      editProps: {},
      previewProps: null,
    };
  },
  watch: {
    edit: function () {
      this.editProps.target = this.props.target ?? "";
      this.editProps.pt = this.props.pt ?? 0;
      this.editProps.pb = this.props.pb ?? 0;

      this.editProps.color_background = {};
      this.editProps.color_background.type = "color";
      this.editProps.color_background.name = "color_background";
      this.editProps.color_background.value =
        this.props.color_background ?? "#FFFFFF";

      this.editProps.img_href = {};
      this.editProps.img_href.type = "image";
      this.editProps.img_href.name = "img_href";
      this.editProps.img_href.value = this.props.img_href ?? "";

      this.editProps.img_width = {};
      this.editProps.img_width.type = "number";
      this.editProps.img_width.name = "img_width";
      this.editProps.img_width.value = this.props.img_width ?? 160;

      this.editProps.headline = {};
      this.editProps.headline.type = "text";
      this.editProps.headline.name = "headline";
      this.editProps.headline.value = this.props.headline ?? {};

      this.editProps.text = {};
      this.editProps.text.type = "text";
      this.editProps.text.name = "text";
      this.editProps.text.value = this.props.text ?? {};

      this.editProps.link_text = {};
      this.editProps.link_text.type = "text";
      this.editProps.link_text.name = "link_text";
      this.editProps.link_text.value = this.props.link_text ?? {};

      this.editProps.button_text = {};
      this.editProps.button_text.type = "text";
      this.editProps.button_text.name = "button_text";
      this.editProps.button_text.value = this.props.button_text ?? {};

      this.editProps.link = {};
      this.editProps.link.type = "link";
      this.editProps.link.name = "link";
      this.editProps.link.value = this.props.link ?? "";
    },
  },
  computed: {
    ...mapState({
      language: state => {
        return state.language ?? "de";
      },
    }),
  },
  methods: {
    save(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
      this.$emit("save", this.previewProps, this.index, this.componentId);
    },
    cancel() {
      this.$emit("cancel");
    },
    setPreviewProps(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
    },
  },
  components: {
    Core,
    CompImageText,
  },
};
</script>

<style></style>
